<button
  type="button"
  class="cell__dot-button"
  [class.cell__dot-button--pressed]="isShowContextMenu"
  (click)="showContextMenu()">
    <span class="cell__icon" [ngClass]="icon"></span>
</button>
<sc-action-menu
  *ngIf="isShowContextMenu"
  class="sc-context-menu"
  [items]="items"
  (actionClicked)="onActionClicked($event)">
</sc-action-menu>
